import {
  useEditorContext,
  useQueryEditor,
} from '@graphiql/react';
import { useEffect, useRef } from "react";
import { VscWand } from "react-icons/vsc";
import useGqlGenerator from "./useGqlGenerator";
import LoadingIndicator from '../../components/LoadingIndicator';

interface InputFieldProps {
  apiId: string;
}

const InputField = ({ apiId }: InputFieldProps) => {
  const {

    queryEditor,

  } = useEditorContext({
    nonNull: true,
    caller: useQueryEditor,
  });
  const inputRef = useRef<HTMLInputElement>(null)


  const {
    fetchGql,
    content,
    loading
  } = useGqlGenerator()


  useEffect(() => {
    if (content) {
      queryEditor.setValue(content || queryEditor.getValue())
    }
  }, [content])

  const handleSubmit: React.KeyboardEventHandler<HTMLInputElement> = async (event) => {
    if (event.key === 'Enter' && !loading) {
      fetchGql(apiId, inputRef.current?.value || '')
    }
  }


  return <div className='px-2 py-1 flex flex-row border mx-2 mb-1' style={{
    flexDirection: 'row',
    alignItems: 'center',
  }}>
    <VscWand className='mr-2' />
    <input ref={inputRef} type="text" placeholder="Ask AI to write here" className="outline-0 flex-1 p-1" onKeyDown={handleSubmit} />
    {loading && <LoadingIndicator />}
  </div>
}
export default InputField;